"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putPaymentLink = void 0;
var putPaymentLink = function (instance) {
    return function (token, body, config) {
        return instance.put("/catalogues/baskets/".concat(token, "/payment-link"), body, config);
    };
};
exports.putPaymentLink = putPaymentLink;
